import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, useRxData } from "rxdb-hooks";
import { EXTERNAL_CODING_REFERENCE, SYNCABLE_META } from "./common";

export const RXDB_INVESTIGATION_CATALOGUE_ITEM_COLLECTION_NAME =
  "investigation-catalogue-item";

export const useRxCollectionInvestigationCatalogueItem =
  (): RxCollection<InvestigationCatalogueItem> | null =>
    useRxCollection<InvestigationCatalogueItem>(
      RXDB_INVESTIGATION_CATALOGUE_ITEM_COLLECTION_NAME,
    );
type UseRxData = Parameters<typeof useRxData<InvestigationCatalogueItem>>;
export type InvestigationCatalogueItemQueryConstructor = UseRxData["1"];
/**
 * @deprecated Use `useRxData<InvestigationCatalogueItem>(RXDB_INVESTIGATION_CATALOGUE_ITEM_COLLECTION_NAME,
 * queryConstructor, options)` instead because this abstraction loses the type
 * inference given to you by the return type of the queryConstructor
 */
export const useRxDataInvestigationCatalogueItem = (
  queryConstructor: UseRxData["1"],
  options?: UseRxData["2"],
) =>
  useRxData<InvestigationCatalogueItem>(
    RXDB_INVESTIGATION_CATALOGUE_ITEM_COLLECTION_NAME,
    queryConstructor,
    options,
  );

export const INVESTIGATION_CATALOGUE_ITEM_SCHEMA_LITERAL = {
  title: "investigation catalogue item schema",
  version: 4,
  description:
    "represents a template for a medical investigation from the elephant catalogue",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    title: {
      type: "object",
      properties: {
        en: {
          type: "string",
        },
      },
      required: ["en"],
    },
    result: {
      type: ["object", "null"],
      properties: {
        resultSchema: {
          type: "object",
        },
      },
      required: ["resultSchema"],
    },
    activityType: {
      type: "string",
    },
    coding: {
      type: ["object", "null"],
      properties: {
        elephant: EXTERNAL_CODING_REFERENCE,
        loinc: EXTERNAL_CODING_REFERENCE,
      },
    },
    version: { type: "integer" },
    keywords: {
      type: ["array", "null"],
      items: {
        type: "object",
        properties: {
          en: {
            type: "string",
          },
        },
        required: ["en"],
      },
    },
  },
  required: [
    "id",
    "title",
    "activityType",
    "version",
    "keywords",
    "coding",
    "result",
  ],
} as const satisfies RxJsonSchema<any>;
const schemaTyped = toTypedRxJsonSchema(
  INVESTIGATION_CATALOGUE_ITEM_SCHEMA_LITERAL,
);

// aggregate the document type from the schema
export type InvestigationCatalogueItem =
  ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

// create the typed RxJsonSchema from the literal typed object.
export const INVESTIGATION_CATALOGUE_ITEM_SCHEMA: RxJsonSchema<InvestigationCatalogueItem> =
  INVESTIGATION_CATALOGUE_ITEM_SCHEMA_LITERAL;
